import { gql } from '@apollo/client';

const UpdateUserSettingMutation = gql`
    mutation ($input: UpdateSettings!) {
        updateSettings(input: $input) {
            data {
                allow_notifications
                createdAt
                id
                show_notifications
                theme
                updatedAt
                user_id
            }
            message
            success
        }
    }
`;

export { UpdateUserSettingMutation };
